<template>
  <fragment>
    <div
      v-if="graphData.length"
      class="graph-container"
    >
      <div class="graph-container">
        <div class="sac__font-10 f-white semi-bold">
          Last 5 days
        </div>
        <highcharts
          class="leak-chart"
          :options="chartOptions"
        />
      </div>
    </div>
    <div v-else class="no-graph-container">
      Graph data not available
    </div>
  </fragment>
</template>

<script>
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';
import makeLeakGraphData from '@shared/lib/lead/makeLeakGraphData';
import serviceMixin from '@shared/mixins/serviceMixin';

export default {
  name: 'WaterLeakGraph',
  mixins: [serviceMixin, unitPreferencesMixin],
  props: {
    alertDetail: Object,
  },
  computed: {
    graphData() {
      const {
        graphData,
      } = this.alertDetail;

      const {
        dateFormat,
      } = this;

      return makeLeakGraphData(graphData, dateFormat);
    },
    chartOptions() {
      return {
        title: {
          text: '',
          style: {
            fontSize: 10,
            fontWeight: 500,
            fontFamily: 'Gilroy, sans-serif',
          },
        },
        chart: {
          type: 'line',
          width: null,
          height: 220,
          backgroundColor: 'transparent',
          spacingBottom: 10,
          spacingLeft: 0,
          spacingRight: 0,
          spacingTop: 30,
          animation: false,
        },
        credits: {
          enabled: false,
        },
        yAxis: {
          min: 0,
          max: 1,
          opposite: true,
          gridLineWidth: 0,
          labels: {
            style: {
              fontSize: 8,
              color: 'white',
              fontWeight: 'bold',
            },
            formatter() {
              if (this.value === 0) {
                return '<img src="https://smac-images.s3.us-west-2.amazonaws.com/noc/no-leak.png" width="40" height ="40">';
              }
              if (this.value === 1) { return '<img src="https://smac-images.s3.us-west-2.amazonaws.com/noc/active-leak.png" width="40" height ="40">'; }
              return '';
            },
            useHTML: true,
          },
          title: {
            text: false,
          },
        },
        xAxis: [{
          lineWidth: 0,
          tickInterval: 6,
          tickPositions: [5, 11, 17, 23, 29, 35, 41, 47, 53, 59, 65, 71, 77, 83, 89, 95, 101, 107, 113, 119],
          categories: this.graphData.map((data) => data.x),
          labels: {
            style: {
              fontSize: 8,
              color: 'white',
              fontWeight: 'bold',
              fontFamily: 'Gilroy, sans-serif',
            },
            formatter() {
              if (this.value < 13) {
                return `${this.value}A`;
              }
              return `${this.value - 12}P`;
            },
          },
        }, {
          lineWidth: 0,
          categories: this.graphData.map((data) => data.x2),
          tickInterval: 24,
          tickPositions: [0, 24, 48, 72, 96, 120],
          linkedTo: 0,
          labels: {
            style: {
              fontSize: 8,
              color: 'white',
              fontWeight: 'bold',
              fontFamily: 'Gilroy, sans-serif',
            },
          },
        }],
        plotOptions: {
          series: {
            enableMouseTracking: false,
            label: {
              connectorAllowed: true,
            },
            connectNulls: true,
            animation: {
              duration: 0,
            },
            lineWidth: 5,
            marker: {
              radius: 0,
            },
          },
        },
        series: [{
          showInLegend: false,
          name: '',
          color: '#2759E4',
          data: this.graphData.map((data) => data.y),
          step: 'right',
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 2000,
            },
          }],
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.no-graph-container {
  display: grid;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: $N50;
  border: 2px solid $N70;
}
</style>
